@if (description()) {
	<p>{{ description() }}</p>
	<div class="blue-line"></div>
}

@for (section of renderedSections(); track $index) {
	<!--
		Each pass is one passage of text and the video that illustrates it. Every part is
		optional, so a section can be a headed step, plain prose, or a standalone clip.
	-->
	@if (section.header) {
		<!-- h4: the panel header renders the document title as the h3 above these. -->
		<h4 class="kb-section-heading">{{ section.header }}</h4>
	}

	@if (section.content) {
		<div
			class="trix-content"
			[innerHTML]="section.content"
		></div>
	}

	@if (section.videoUrl) {
		<div class="embed-responsive embed-responsive-16by9 kb-video">
			<iframe
				class="embed-responsive-item"
				[title]="section.videoTitle"
				[src]="section.videoUrl | safe"
				allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
				allowfullscreen
			></iframe>
		</div>
	}
}
